<template>
  <div class="product-carousel swiper mySwiper1">
    <div class="swiper-wrapper">
      <template v-for="(items, index) in productList">
        <div :key="index" class="swiper-slide" style="display: flex; justify-content: space-between;">
          <template v-for="(item, i) in items">
            <custom-product :key="i" :product="item" style="width: 16%; display: inline-block;" :jump-path="jumpPath" :isShowProgress="isShowProgress" :isShowName="true" :isLazy="false" :kklocation="kklocation" :reportType="reportType" />
          </template>
          <template v-if="items.length < 6">
            <div v-for="num in (6 - items.length)" :key="'num'+num" style="width: 16%; display: inline-block;"></div>
          </template>
        </div>
      </template>
    </div>

    <div class="arrow previous-page pointer" @click="previousPage">
      <i class="iconfont icon-a-arrow-left-s-line2" />
    </div>
    <div class="arrow next-page pointer" @click="nextPage">
      <i class="iconfont icon-a-arrow-right-s-line1" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import Product from '@/components/Product.vue'

export default {
  props: {
    productList: {
      type: Array,
      default: () => ([])
    },
    swiperOptions: {
      type: Object,
      default: () => ({})
    },
    jumpPath: {
      type: String,
      default: ''
    },
    slideindex: {
      type: Number,
      default: 0
    },
    isShowProgress: {
      type: Boolean,
      default: false
    },
    kklocation: {
      type: String,
      default: ''
    },
    reportType: {
      type: String,
      default: ''
    },
    discountId: {
      type: String,
      default: ''
    }
  },
  components: {
    'custom-product': Product
  },
  data() {
    return {
      index: 0,
      swiper: null
    }
  },
  watch: {
    productList: function(i) {
      if (!this.swiper && this.productList.length > 0) {
        this.initSwiper()
      }
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('.mySwiper1', {
          simulateTouch: false,
          prevButton: '.previous-page',
          nextButton: '.next-page',
          loop: true,
          ...this.swiperOptions
        })
      })
    },
    nextPage() {
      this.allActivityProductClick()
    },
    previousPage() {
      this.allActivityProductClick()
    },
    // 活动点击埋点
    allActivityProductClick() {
      if (this.reportType === 'activity' && this.discountId) {
        this.$record({
          eventType: 'click',
          eventId: `allActivityProduct_click`,
          value: JSON.stringify({ discountId: this.discountId, type: 'activity' })
        })
      }
      if (this.reportType === 'album' && this.moduleId) {
        this.$record({
          eventType: 'click',
          eventId: `allAlbumProduct_click`,
          value: JSON.stringify({ moduleId: this.moduleId, type: 'album' })
        })
      }
    }
  }
}
</script>

<style lang="scss">
.product-carousel{
  width: 100%;
  overflow: hidden;
  position: relative;
  .arrow{
    position: absolute;
    width: 40px;
    height: 40px;
    top: calc(50% - 40px);
    border-radius: 100%;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 8px 4px -5px rgba(0, 0, 0, 0.4), 0px 16px 24px 2px rgba(0, 0, 0, 0.1), 0px 6px 30px 5px rgba(0, 0, 0, 0.1);
    z-index: 9;
    text-align: center;
    display: none;
  }
  .previous-page{
    left: 8px;
  }
  .next-page{
    right: 8px;
  }
  .next-page i,.previous-page i{
    line-height: 50px;
    font-size: 30px;
  }
}
.product-carousel:hover .arrow{
  display: block;
}
.product-carousel .next-page i, .product-carousel .previous-page i {
  line-height: 40px;
  color: #606266;
}
</style>
